import { render, staticRenderFns } from "./JobsWidget.vue?vue&type=template&id=027c739c"
import script from "./JobsWidget.vue?vue&type=script&lang=js"
export * from "./JobsWidget.vue?vue&type=script&lang=js"
import style0 from "./JobsWidget.vue?vue&type=style&index=0&id=027c739c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports